var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"margin":"0px","padding":"0"},attrs:{"fluid":""}},[_c('line-c',{attrs:{"data":_vm.data,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }